<template>
  <button style="height: 48px;"
          :class="`color-${color} hover-color-${hoverColor}`"
          class="button px-3 rounded-lg flex items-center text-white text-sm font-bold transition"
          @click="$emit('click', $event)"
  >
    <div v-if="download" style="width: 24px; height: 48px;"
         class="flex justify-center items-center pointer-events-none"
    ><img width="24" height="24" :src="require('@/assets/images/meeting-note/download_white.svg')" /></div>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'RoomMeetingNoteButton',
  props: {
    download: { type: Boolean, default: true },
    color: { type: String, default: 'blue' },
    hoverColor: { type: String, default: function() { return this.color } },
  },
}
</script>

<style lang="scss" scoped>
.color- {
  &gray { @apply bg-gray-400 }
  &red { @apply bg-red-400 }
  &yellow { @apply bg-yellow-400 }
  &green { @apply bg-green-600 }
  &blue { @apply bg-blue-400 }
  &indigo { @apply bg-indigo-400 }
  &purple { @apply bg-purple-400 }
  &pink { @apply bg-pink-400 }
  &black { @apply bg-black }
  &navy { @apply bg-navy }
}

.hover-color- {
  &gray { @apply hover:bg-gray-600 }
  &red { @apply hover:bg-red-600 }
  &yellow { @apply hover:bg-yellow-600 }
  &green { @apply hover:bg-green-800 }
  &blue { @apply hover:bg-blue-600 }
  &indigo { @apply hover:bg-indigo-600 }
  &purple { @apply hover:bg-purple-600 }
  &pink { @apply hover:bg-pink-600 }
}
</style>